import React from 'react';

interface SmallTagProps {
  children: React.ReactNode;
  className?: string;
}

export const Subtitle: React.FC<SmallTagProps> = ({
  children,
  className = '',
}) => {
  return (
    <div
      className={`text-28 sm:text-44 font-semibold text-white ${className}`}
    >
      {children}
    </div>
  );
};

export default Subtitle; 